import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../shared/theme/useColorScheme";

interface IAppLoadingScreenStyles {
  layout: ICSSInJSStyle;
}

export const useAppLoadingScreenStyles: () => IAppLoadingScreenStyles = () => {
  const screenHeight = document.documentElement.clientHeight;
  const { main } = useFluentColorScheme();
  return {
    layout: {
      width: "100%",
      minHeight: screenHeight + "px",
      backgroundColor: main.background2,
    },
  };
};
